import MainScript from './main.js'
import DesktopView from './desktop/desktop.vue';
//
import ItemsList from './../Components/V_ItemsOrder/index.vue';
// let service = new services();
export default {
    name: 'Business',
    mixins: [MainScript],
    data () {
        return {}
    },
  
    components: {
        'component-desktop':DesktopView,
        //
        'items-list': ItemsList,
    },
  
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/Business/script.js